import { ActionMenu } from "@telluscompany/design-system";
import { Edit, MoreVertical, Trash2 } from "lucide-react";
import { useLocalization } from "@i18n";
import type { LicenseListItem } from "../../api/licenses/licenses.types";

interface LicensesActionMenuProps {
  license: LicenseListItem;
  onEdit: (license: LicenseListItem) => void;
  onDelete: (license: LicenseListItem) => void;
}

export const LicensesActionMenu = ({
  license,
  onEdit,
  onDelete,
}: LicensesActionMenuProps) => {
  const { translate } = useLocalization();

  const actions = [
    {
      actions: [
        {
          label: translate("management.licenses.button.edit"),
          onClick: () => onEdit(license),
          icon: <Edit size={16} />,
        },
        {
          label: translate("management.licenses.button.delete"),
          onClick: () => onDelete(license),
          icon: <Trash2 size={16} />,
          colorTitle: "red" as const,
        },
      ],
    },
  ];

  return <ActionMenu menu={actions} trigger={<MoreVertical size={20} />} />;
};
